<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="规则名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="20"
            v-decorator="[
              'ruleName',
              {
                rules: [
                  { required: true, message: '请输入规则名称,限制20个字' },
                ],
              },
            ]"
            placeholder="请输入规则名称,限制20个字"
          />
        </a-form-item>
        <a-form-item
          label="活动规则类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['ruleType']"
            placeholder="请选择规则类型"
            @change="fieldValue"
          >
            <a-select-option
              v-for="(item, index) in ruleTypeList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="活动规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="showUpload"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['ruleImgUrl']"
          />
        </a-form-item>
        <a-form-item
          label="活动规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="showEditor"
        >
        <input type="textarea" v-show="false" v-decorator="['ruleText']" />
          <tinymce-editor
            :value="this.form.getFieldValue('ruleText')"
            @change="getMyValue"
          />
        </a-form-item>
        <!--<a-form-item label="规则状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="['status']" placeholder="请选择规则状态" :triggerChange="true" dictCode="obj_status"/>
        </a-form-item>-->
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util'
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
// import { getAction } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';
import tinymceEditor from '@/components/tools/tinymceEditor';

export default {
  name: 'MarketActivityRuleModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
    UploadImage,
    tinymceEditor,
  },
  data() {
    return {
      fileList: '',
      showEditor: false,
      showUpload: false,
      // editorOption: {
      //   modules: {
      //     toolbar: [
      //       [
      //         'bold',
      //         { header: 1 },
      //         { header: 2 },
      //         { color: [] },
      //         { font: [] },
      //         { size: ['small', false, 'large', 'huge'] },
      //         'italic',
      //         'underline',
      //         'strike',
      //       ], // toggled buttons
      //       [
      //         'blockquote',
      //         { indent: '-1' },
      //         { indent: '+1' },
      //         { align: [] },
      //         'clean',
      //       ],
      //     ],
      //   },
      // },
      headers: {
        authorization: 'authorization-text',
      },
      ruleTypeList: [
        {
          name: '请选择',
          value: 0,
        },
        {
          name: '图片',
          value: 1,
        },
        {
          name: '文本',
          value: 2,
        },
      ],
      category: '0',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/marketActivityRule/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/marketActivityRule/edit',
        typeList: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/typeList',
      },
    };
  },
  created() {},
  methods: {
    getMyValue(val) {
      this.form.setFieldsValue({
        ruleText: val,
      });
    },
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.fileList = record.ruleImgUrl;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          ruleImgUrl: record.ruleImgUrl
            ? process.env.VUE_APP_FILE_PATH + record.ruleImgUrl
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'ruleName',
            'ruleType',
            'ruleText',
            // 'ruleImgUrl',
            'status'
          )
        );
      });

      if (this.model.ruleType === 1) {
        this.showEditor = false;
        this.showUpload = true;
      } else if (this.model.ruleType === 2) {
        this.showEditor = true;
        this.showUpload = false;
      } else {
        this.showEditor = false;
        this.showUpload = false;
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          formData.ruleImgUrl = this.fileList;
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(row, 'ruleName', 'ruleType', 'ruleText', 'ruleImgUrl', 'status')
      );
    },

    onEditorBlur(){//失去焦点事件
    },
    onEditorFocus(){//获得焦点事件
    },
    onEditorChange(){//内容改变事件
    },

    fieldValue(e) {
      if (e === 1) {
        this.showUpload = true;
        this.showEditor = false;
      } else if (e === 2) {
        this.showEditor = true;
        this.showUpload = false;
      } else {
        this.showEditor = false;
        this.showUpload = false;
      }
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        ruleImgUrl: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}